import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { VerifyInstrumentRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { VerifyInstrumentResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const verifyInstrument = (request: VerifyInstrumentRequest, options?: CashRequestOptions) =>
  post<VerifyInstrumentRequest, VerifyInstrumentResponse>('/2.0/cash/verify-instrument', request, {
    ...options,
    rejectOnError: true,
  })
